import React from 'react'
import './spinner.css'

const Spinner = () => {
  return (
    <div className='flex justify-center items-center'>
      <div className='loader'></div>
    </div>
  )
}

export default Spinner
